import React, { Component } from 'react';
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  DialogActions,
  Grid,
  TextField,
  Snackbar
} from '@material-ui/core';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import CloseIcon from '@material-ui/icons/Close';
import SelectReact from 'react-select';
import i18n from '../../i18n';
import '../../assets/stylesheets/Closet.css';
import { snackbarDuration } from '../../constants/general';
import { fetchLocations } from '../../helpers/externalRequests';

import closetCartSlice, { requestItems as requestItemsThunk } from '../../collections/closetCart';

class RequestItemsModal extends Component {

  constructor(props) {
    super(props);

    this.state = {
      allLocations: [],
      locationsLoaded: false,
      locationId: null,
      comments: '',
      snackbar: {
        open: false,
        message: ''
      }
    }
  }

  componentDidMount() {
    this.getLocations();
  }

  locationIsEmpty = () => {
    const { locationsLoaded, allLocations } = this.state;
    return locationsLoaded && allLocations.length === 0
  }

  isReady = () => {
    const { comments, locationId } = this.state;

    return this.locationIsEmpty() ? comments !== '' : locationId != null
  }

  handleChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleSelectChange = (selectedItem, select) => {
    this.setState({ [select.name]: selectedItem.value });
  }

  sendRequest = async () => {
    if (!this.isReady()) {
      this.openSnackbar(i18n.t('closet:requestMissingFields'))
      return;
    }
    const { requestItems, onClose } = this.props;
    const { comments, locationId } = this.state;

    try {
      await requestItems({ locationId, comments })
      onClose()
    } catch (e) {
      this.openSnackbar(i18n.t('closet:errorSendingRequest'));
      console.error(e);
    }
  }

  getLocations = async () => {
    try {
      const allLocations = await fetchLocations({ locationTypeId: 2, isActive: true });
      this.setState({
        allLocations: allLocations.data,
        locationsLoaded: true
      });
    } catch (e) {
      this.setState({
        allLocations: [],
        locationsLoaded: true
      });
      console.error(i18n.t('closet:errorFetchingLocations', { details: e.message }));
    }

  };

  openSnackbar = (message) => {
    this.setState({
      snackbar: {
        message,
        open: true
      }
    });
  }

  closeSnackbar = () => {
    this.setState({
      snackbar: {
        message: '',
        open: false
      }
    });

  }

  getLocationOptions = () => {
    const { allLocations } = this.state;
    return allLocations.map((location) => {
      return {
        label: location.locationName,
        value: location.id
      }
    });
  }

  render() {
    const { snackbar, locationId, comments } = this.state;
    const { itemsTotal, showModal, onClose } = this.props;
    const locationOptions = this.getLocationOptions();
    return (
      <Dialog
        open={showModal}
        onClose={onClose}
        scroll='paper'
        className='requestItemsModal'
      >
        <IconButton className="closeDialogIcon" aria-label="close" onClick={onClose}>
          <CloseIcon />
        </IconButton>
        <DialogTitle>
          {i18n.t('closet:requestingItems', { nb: itemsTotal })}
        </DialogTitle>
        <DialogContent>
          <Grid container>
            <Grid item xs={12}>
              {(
                this.locationIsEmpty() ? i18n.t('closet:noLocationError') :
                <SelectReact
                  fullWidth
                  required
                  hideSelectedOptions
                  name="locationId"
                  placeholder={i18n.t('closet:selectYourLocation')}
                  value={locationOptions.find(opt => opt.value === locationId)}
                  options={locationOptions}
                  onChange={this.handleSelectChange}
                />
              )}
            </Grid>
            <Grid item xs={12}>
              <TextField
                multiline
                fullWidth
                name="comments"
                label={i18n.t('comments')}
                value={comments}
                onChange={this.handleChange}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={this.sendRequest}
            className={`ssenseButton ${this.isReady() ? 'ssensePrimary' : 'ssenseDefault'}`}
          >
            {i18n.t('closet:sendRequest')}
          </Button>
          <Button
            onClick={onClose}
            className="ssenseButton ssenseDefault"
          >
            {i18n.t('close')}
          </Button>
        </DialogActions>

        <Snackbar
          message={snackbar.message}
          open={snackbar.open}
          onClose={this.closeSnackbar}
          autoHideDuration={snackbarDuration}
        />
      </Dialog>
    );
  }
}

const mapDispatchToProps = {
  clearCart: closetCartSlice.actions.clear,
  requestItems: requestItemsThunk
};

const mapStateToProps = state => ({
  itemsTotal: state.closetCart.total
});

RequestItemsModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  itemsTotal: PropTypes.number.isRequired,
  onClose: PropTypes.func.isRequired,
  requestItems: PropTypes.func.isRequired
}

export { RequestItemsModal as RequestItemsModalNoConnect }
export default connect(mapStateToProps, mapDispatchToProps)(RequestItemsModal);
